import { useState, useEffect } from "react";
import { Box, Text } from "@chakra-ui/react";
import MarkdownRenderer from "../../components/stringtomarkdown/Stringtomarkdown";

// Helper function to convert markdown content to plain text
const markdownToPlainText = (markdown) => {
  const div = document.createElement("div");
  div.innerHTML = markdown;
  return div.textContent || div.innerText || "";
};

export const MarkDownConerter = ({ paragraph }) => {
  const plainText = markdownToPlainText(paragraph);

  return (
    <Box>
      <MarkdownRenderer
        components={{
          strong: ({ node, ...props }) => (
            <Text as="strong" color="red" fontWeight="bold" {...props} />
          ),
        }}
        content={plainText}
      />
    </Box>
  );
};
